import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import Button from "components/buttons";
import { withRouter } from "react-router-dom";
import styles from "./styles/form-cancel.css.js";

const FormCancel = ({ classes, children, onClick, history, fullWidth = false, disabled }) => (
  <Button
    fullWidth={fullWidth}
    variant="contained"
    className={classes.cancelButton}
    onClick={onClick || history.goBack}
    disabled={disabled}
  >
    {children}
  </Button>
);

FormCancel.propTypes = {
  /**
   * Indica si se muestra en ancho completo
   */
  fullWidth: PropTypes.bool,
  /**
   * Callback de click
   */
  onClick: PropTypes.func,
};

export default withRouter(withStyles(styles)(FormCancel));
